import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuardService } from '../../authentication/auth-guard.service';
import { OnHoldProjectListComponent } from './on-hold-project-list.component';
import { MatTooltipModule } from '@angular/material';

const routes = [
  { path: '', redirectTo: 'on-hold-project-list', pathMatch: 'full', canActivate: [AuthGuardService] },
  { path: 'on-hold-project-list', component: OnHoldProjectListComponent, canActivate: [AuthGuardService] },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatTooltipModule
  ],
  declarations: []
})
export class OnHoldProjectListModule { }
